import { CatButton } from '@blocks-react/components/Button';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import { useBreakpoint } from '../../../hooks';

type ServiceRecommendationModelFooterProps = {
  buttonText: string;
  requestServiceBtn: string;
  isAddPartsEnabled: boolean;
  handleRequestService: () => void;
  handleAddToCart: () => void;
};

export const ServiceRecommendationModelFooter = ({
  buttonText,
  requestServiceBtn,
  isAddPartsEnabled,
  handleRequestService,
  handleAddToCart
}: Readonly<ServiceRecommendationModelFooterProps>) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const width = !isMD ? 'w-100' : '';
  return (
    <div
      slot="footer"
      style={{
        display: 'flex',
        gap: '8px',
        marginTop: '26px'
      }}
      data-testid="model-footer-container"
      className={!isMD ? 'flex-column' : ''}
    >
      {isAddPartsEnabled && (
        <CatButton
          fullWidth={!isMD}
          variant="primary"
          size="sm"
          onClick={handleAddToCart}
          className={width}
          data-testid="add-to-partcart"
          ariaControls={buttonText}
        >
          {buttonText}
        </CatButton>
      )}
        <CatButton
          fullWidth={!isMD}
          size="sm"
          onClick={handleRequestService}
          className={width}
          data-testid="request-service-btn"
          ariaControls={requestServiceBtn}
        >
          {requestServiceBtn}
        </CatButton>
    </div>
  );
};
